import { html, nothing } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import componentStyles from './icon.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';

import arrow from './assets/icons/arrow.svg';
import arrowLeft from './assets/icons/arrow-left.svg';
import arrowRight from './assets/icons/arrow-right.svg';
import asterisk from './assets/icons/asterisk.svg';
import avatar from './assets/icons/avatar.svg';
import badge from './assets/icons/badge.svg';
import bones from './assets/icons/bones.svg';
import brain from './assets/icons/brain.svg';
import businesshandshake from './assets/icons/business-deal-handshake.svg';
import calendarCheck from './assets/icons/calendar-check.svg';
import calendarLarge from './assets/icons/calendar-large.svg';
import calendarSmall from './assets/icons/calendar-small.svg';
import cloud from './assets/icons/cloud.svg';
import chat from './assets/icons/chat.svg';
import checked from './assets/icons/checked.svg';
import chevronLeft from './assets/icons/chevron-left.svg';
import chevronRight from './assets/icons/chevron-right.svg';
import chevronDown from './assets/icons/chevron-down.svg';
import chevronUp from './assets/icons/chevron-up.svg';
import close from './assets/icons/close.svg';
import construction from './assets/icons/construction.svg';
import dna from './assets/icons/dna.svg';
import female from './assets/icons/female.svg';
import feed from './assets/icons/feed.svg';
import filter from './assets/icons/filter.svg';
import fingerPoint from './assets/icons/finger-point.svg';
import giveHand from './assets/icons/give-hand.svg';
import globe from './assets/icons/globe.svg';
import heartCross from './assets/icons/heart-cross.svg';
import heartEmpty from './assets/icons/heart-empty.svg';
import heartFull from './assets/icons/heart-full.svg';
import hfLogo from './assets/icons/hf-logo.svg';
import hfMark from './assets/icons/hf-mark.svg';
import hpLogo from './assets/icons/hp-logo.svg';
import hLeft from './assets/icons/h-left.svg';
import hRight from './assets/icons/h-right.svg';
import hospitalBuilding from './assets/icons/hospital-building.svg';
import hospitalSign from './assets/icons/hospital-sign.svg';
import hurricane from './assets/icons/hurricane.svg';
import insuranceCard from './assets/icons/insurance-card.svg';
import list from './assets/icons/list.svg';
import location from './assets/icons/location.svg';
import pinDefault from './assets/icons/pin-default.svg';
import pinSelected from './assets/icons/pin-selected.svg';
import map from './assets/icons/map.svg';
import externalLink from './assets/icons/external-link.svg';
import medicalCross from './assets/icons/medical-cross.svg';
import medicalCrossSearch from './assets/icons/medical-cross-search.svg';
import medicalCrossSquare from './assets/icons/medical-cross-square.svg';
import medicalDocument from './assets/icons/medical-document.svg';
import menu from './assets/icons/menu.svg';
import minus from './assets/icons/minus.svg';
import money from './assets/icons/money.svg';
import numberOne from './assets/icons/number-1.svg';
import numberTwo from './assets/icons/number-2.svg';
import numberThree from './assets/icons/number-3.svg';
import numberFour from './assets/icons/number-4.svg';
import openBook from './assets/icons/open-book.svg';
import phone from './assets/icons/phone.svg';
import phoneBook from './assets/icons/phone-book.svg';
import print from './assets/icons/print.svg';
import pills from './assets/icons/pills.svg';
import play from './assets/icons/play.svg';
import plus from './assets/icons/plus.svg';
import power from './assets/icons/power.svg';
import questionCircle from './assets/icons/question-circle.svg';
import quote from './assets/icons/quote.svg';
import scale from './assets/icons/scale.svg';
import search from './assets/icons/search.svg';
import share from './assets/icons/share.svg';
import shoe from './assets/icons/shoe.svg';
import shop from './assets/icons/shop.svg';
import smileyFace from './assets/icons/smiley-face.svg';
import stethoscope from './assets/icons/stethoscope.svg';
import virus from './assets/icons/virus.svg';
import warning from './assets/icons/warning.svg';

import facebook from './assets/icons/social-facebook.svg';
import instagram from './assets/icons/social-instagram.svg';
import linkedin from './assets/icons/social-linkedin.svg';
import twitter from './assets/icons/social-twitter-x.svg';
import youtube from './assets/icons/social-youtube.svg';

import car from './assets/icons/car.svg';
import drugs_box from './assets/icons/drugs_box.svg';
import make_up_eye from './assets/icons/make_up_eye.svg';
import medical_specialty_ear from './assets/icons/medical_specialty_ear.svg';
import person_single from './assets/icons/person_single.svg';
import salad from './assets/icons/salad.svg';
import smartwatch from './assets/icons/smartwatch.svg';
import tooth_solid from './assets/icons/tooth_solid.svg';

export const icons = {
  'hf-logo': hfLogo,
  'hf-mark': hfMark,
  'hp-logo': hpLogo,
  arrow,
  'arrow-left': arrowLeft,
  'arrow-right': arrowRight,
  asterisk,
  avatar,
  badge,
  bones,
  brain,
  'business-deal-handshake': businesshandshake,
  'calendar-check': calendarCheck,
  'calendar-large': calendarLarge,
  'calendar-small': calendarSmall,
  chat,
  checked,
  'chevron-left': chevronLeft,
  'chevron-right': chevronRight,
  'chevron-down': chevronDown,
  'chevron-up': chevronUp,
  close,
  dna,
  female,
  feed,
  filter,
  'finger-point': fingerPoint,
  'give-hand': giveHand,
  globe,
  'heart-cross': heartCross,
  'heart-empty': heartEmpty,
  'heart-full': heartFull,
  'hospital-building': hospitalBuilding,
  'hospital-sign': hospitalSign,
  'insurance-card': insuranceCard,
  list,
  location,
  'pin-default': pinDefault,
  'pin-selected': pinSelected,
  map,
  'medical-cross': medicalCross,
  'medical-cross-search': medicalCrossSearch,
  'medical-cross-square': medicalCrossSquare,
  'medical-document': medicalDocument,
  'number-1': numberOne,
  'number-2': numberTwo,
  'number-3': numberThree,
  'number-4': numberFour,
  menu,
  minus,
  money,
  'open-book': openBook,
  phone,
  'phone-book': phoneBook,
  print,
  pills,
  play,
  plus,
  'question-circle': questionCircle,
  quote,
  scale,
  search,
  shoe,
  shop,
  'smiley-face': smileyFace,
  stethoscope,
  virus,
  warning,
  facebook,
  instagram,
  linkedin,
  twitter,
  youtube,
  'h-left': hLeft,
  'h-right': hRight,
  construction,
  cloud,
  hurricane,
  share,
  power,
  'external-link': externalLink,
  car,
  drugs_box,
  make_up_eye,
  medical_specialty_ear,
  person_single,
  salad,
  smartwatch,
  tooth_solid,
};

export default class Icon extends OutlineElement {
  static styles = [super.styles, componentStyles];
  static get properties() {
    return {
      name: { type: String },
      color: { type: String },
      styleclass: { type: String },
    };
  }

  constructor() {
    super();
    this.styleclass = '';
  }

  render() {
    return this.name === undefined
      ? nothing
      : html`
          <div
            class=${classMap({
              icon: true,
              [`text-${this.color}`]: this.color !== undefined,
              [`icon--${this.styleclass}`]: !!this.styleclass,
            })}
          >
            ${unsafeHTML(icons[this.name])}
          </div>
        `;
  }
}

customElements.define('hf-icon', Icon);
